import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const BenefitItem = ({ icon, title, description }) => {
  const [Icon, setIcon] = useState(null);

  useEffect(() => {
    import(`@/images/${icon}.png`).then(module => setIcon(module.default));
  }, [icon]);

  return (
    <div className="flex flex-col lg:flex-row items-center lg:gap-4">
      <img src={Icon} alt={title} className="py-6 h-[112px]" />
      <div>
        <h3 className="text-lg mb-3 font-semibold">{title}:</h3>
        <div className="text-base font-normal">{parse(description)}</div>
      </div>
    </div>
  );
};

BenefitItem.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default BenefitItem;
